let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gZ001")).then(() => parcelRequire('b8TQj'));